var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { Subscription } from "./../models/V1/Companies/Subscriptions/Subscription";
import { SubscriptionFactory } from "./../models/V1/Companies/Subscriptions/SubscriptionFactory";
export class CompaniesSubscriptions {
  /**
   * Creates an instance of CompaniesSubscriptions.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CompaniesSubscriptions
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param UpdateSubscriptionDatesRq_ _updateSubscriptionDatesRq
   * @returns Promise<UpdateSubscriptionDatesRq_>
   * @memberof CompaniesSubscriptions
   */
  updateSubscriptionDates(pUpdateSubscriptionDatesRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/subscriptions/{subscriptionId}",
      "PATCH",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pUpdateSubscriptionDatesRq.companyId, required: true },
      { name: "subscriptionId", value: pUpdateSubscriptionDatesRq.subscriptionId, required: true }
    ]);
    client.addBody({ value: pUpdateSubscriptionDatesRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 400, clazz: ApiError }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CancelSubscriptionRq_ _cancelSubscriptionRq
   * @returns Promise<CancelSubscriptionRq_>
   * @memberof CompaniesSubscriptions
   */
  cancelSubscription(pCancelSubscriptionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/companies/{companyId}/subscriptions/{subscriptionId}",
      "DELETE",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pCancelSubscriptionRq.companyId, required: true },
      { name: "subscriptionId", value: pCancelSubscriptionRq.subscriptionId, required: true }
    ]);
    client.addBody({ value: pCancelSubscriptionRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetCompanySubscriptionsRq_ _getCompanySubscriptionsRq
   * @returns Promise<GetCompanySubscriptionsRq_>
   * @memberof CompaniesSubscriptions
   */
  getCompanySubscriptions(pGetCompanySubscriptionsRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/companies/{companyId}/subscriptions", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "companyId", value: pGetCompanySubscriptionsRq.companyId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: Subscription, isArray: true, factory: SubscriptionFactory },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 422, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
